<div class="content-wrapper">
    <div class="content-body">
        <section id="partner-linked-universities">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <h2 class="mt-5px">Linked Universities</h2>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <button class="btn btn-primary pull-right color-white users-btn cursor-pointer"
                            (click)="toggleLinkPanel()">
                        <i aria-hidden="true" class="fa fa-plus-circle mr-8px"></i>&nbsp;Link University
                    </button>
                </div>
            </div>

            <div class="row search-card mt-3" *ngIf="showLinkPanel">
                <div class="col-12">
                    <div class="card p-2">
                        <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                            <div class="row">
                                <div class="col-md-8 col-lg-8 col-sm-8 col-xs-12">
                                    <fieldset class="form-group">
                                        <input class="form-control" type="text" formControlName="name"
                                               placeholder="Search university by name or short name"
                                               (keyup)="search()">
                                    </fieldset>
                                </div>
                                <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12">
                                    <i class="fas fa-spinner fa-pulse mr-1" *ngIf="searching"></i>
                                </div>
                            </div>
                        </form>
                        <div class="row" *ngIf="searchResults && searchResults.length > 0">
                            <div class="col-12">
                                <div class="d-flex justify-content-between align-items-center py-1"
                                     style="border-bottom: 1px solid #eee"
                                     *ngFor="let university of searchResults">
                                    <span>{{university?.name}} <small class="text-muted">({{university?.short_name}})</small></span>
                                    <button class="btn btn-sm btn-primary color-white" [disabled]="submitting"
                                            (click)="link(university)">Link
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-1" *ngIf="searchForm.value.name && searchResults.length === 0 && !searching">
                            <div class="col-12">
                                <small class="text-muted">No matching university found.</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row d-none d-md-block mt-3">
                <div class="col-12">
                    <div class="card">
                        <div class="container-fluid">
                            <div class="row d-none d-md-block overflow-x-scroll overflow-table">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <table class="table table-list">
                                        <thead>
                                        <tr>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">S.No</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Name</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Short
                                                Name</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Rating</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">City</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Popular</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Action</h6>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody *ngIf="universities && universities.length > 0; else noDataToShowWeb">
                                        <tr *ngFor="let university of universities; let i = index">
                                            <td class="text-center">
                                                <h6 class="mt-1">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}
                                                    .</h6>
                                            </td>
                                            <td class="text-center"><h6 class="mt-1">{{university?.name}}</h6></td>
                                            <td class="text-center"><h6 class="mt-1">{{university?.short_name}}</h6>
                                            </td>
                                            <td class="text-center"><h6 class="mt-1">{{university?.rating}}</h6></td>
                                            <td class="text-center"><h6 class="mt-1">{{university?.city?.name}}</h6>
                                            </td>
                                            <td class="text-center">
                                                <i aria-hidden="true" class="fas fa-star text-warning"
                                                   *ngIf="university?.is_popular" title="Popular"></i>
                                            </td>
                                            <td class="text-center">
                                                <i aria-hidden="true"
                                                   class="fas fa-code-branch f_20 text-primary cursor-pointer mt-1 mr-8px"
                                                   title="PCB Mapping" (click)="pcbMappingPage(university)"></i>
                                                <button class="btn btn-sm btn-danger" [disabled]="submitting"
                                                        (click)="unlink(university)">Unlink
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <ng-template #noDataToShowWeb>
                                            <tbody>
                                            <tr>
                                                <td colspan="7" class="text-center"><h6>No university linked to this
                                                    partner yet</h6></td>
                                            </tr>
                                            </tbody>
                                        </ng-template>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row pagination-table">
                <ngb-pagination (pageChange)="onPageChange($event)"
                                [(page)]="pagination.page"
                                [boundaryLinks]="true"
                                [collectionSize]="pagination.total"
                                [maxSize]="5"
                                [pageSize]="pagination.perpage">
                </ngb-pagination>
            </div>
        </section>
    </div>
</div>
